import { useEffect, useRef, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { useTheme } from '../theme/ThemeProvider';

/** Sağ üst köşedeki kullanıcı ikonu + açılır menü (Profilim, Tema, Şifre Değiştir, Çıkış). */
export function UserMenu() {
  const { user, logout } = useAuth();
  const { resolved, toggle } = useTheme();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const name = user?.full_name || user?.email || '';
  const initials =
    name.trim().split(/\s+/).map((s) => s[0]).slice(0, 2).join('').toUpperCase() || 'U';
  const roleLabel = user?.role === 'bayi' ? 'Bayi' : user?.role === 'manager' ? 'Manager' : 'Yönetici';

  const handleLogout = async () => {
    setOpen(false);
    await logout();
    navigate('/giris', { replace: true });
  };

  return (
    <div className="usermenu" ref={ref}>
      <button
        className="usermenu-btn"
        onClick={() => setOpen((o) => !o)}
        aria-label="Kullanıcı menüsü"
        aria-expanded={open}
      >
        <span className="usermenu-avatar">{initials}</span>
      </button>

      {open && (
        <div className="usermenu-pop" role="menu">
          <div className="usermenu-head">
            <div className="usermenu-name">{name}</div>
            <div className="usermenu-role">{roleLabel}</div>
          </div>
          <NavLink to="/profil" className="usermenu-item" onClick={() => setOpen(false)}>
            <span className="usermenu-ico">◐</span> Profilim
          </NavLink>
          <button className="usermenu-item" onClick={toggle}>
            <span className="usermenu-ico">{resolved === 'dark' ? '☀' : '☾'}</span>
            Tema: {resolved === 'dark' ? 'Koyu' : 'Açık'}
          </button>
          <NavLink to="/sifre" className="usermenu-item" onClick={() => setOpen(false)}>
            <span className="usermenu-ico">⚿</span> Şifre Değiştir
          </NavLink>
          <div className="usermenu-sep" />
          <button className="usermenu-item danger" onClick={handleLogout}>
            <span className="usermenu-ico">⎋</span> Çıkış
          </button>
        </div>
      )}
    </div>
  );
}
